import { create } from 'zustand'
import { getActiveAgentSession } from '@/api/autoagent'

interface AgentState {
  isRunning: boolean
  project: string | null
  setRunning: (running: boolean, project?: string | null) => void
  checkActiveAgent: () => Promise<void>
}

export const useAgentStore = create<AgentState>((set) => ({
  isRunning: false,
  project: null,

  setRunning: (running, project = null) =>
    set({ isRunning: running, project: running ? project : null }),

  checkActiveAgent: async () => {
    try {
      const resp = await getActiveAgentSession()
      set({
        isRunning: resp.active && (resp.status === 'running' || resp.has_running_task),
        project: resp.active ? (resp.project ?? null) : null,
      })
    } catch {
      // Ignore — user may not be logged in yet
    }
  },
}))
